<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nIaQ80/tc-custom/9781504057646.jpg?1726617358930" alt="This image is the cover for the book Masao Masuto Mysteries Volume Two, The Masao Masuto Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Masao Masuto Mysteries Volume Two, The Masao Masuto Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A collection of thrilling murder mysteries featuring “an unusually interesting detective” from the #1 <i>New York Times</i>–bestselling author of <i>Spartacus</i> (<i>The Washington Star</i>).</b><br/><br/> Japanese-American Beverly Hills homicide detective Masao Masuto is a karate expert, a devotee of roses, and a Zen Buddhist. He does his job with a cool, caustic wit—and with surprising force when necessary. He possesses a singular sense of justice, taking action on his own and occasionally pushing the boundaries of the law . . .<br/>  <br/><i>The Case of the Sliding Pool</i>: After a decades-old hidden grave is uncovered by a rainstorm, Detective Masuto must look into the distant past to find a murderer who was very good at his job—and who is about to come out of retirement.<br/>  <br/> “An interesting conception.” —<i>The New York Times</i><br/>  <br/><i>The Case of the Kidnapped Angel</i>: The wife of one of Hollywood’s biggest movie stars has been kidnapped for ransom—one that is willingly paid. But Masuto doesn’t believe the worried husband’s performance. He suspects the payoff was for something deadly . . .<br/>  <br/> “A talent for all times.” —<i>The Moscow News</i><br/>  <br/><i>The Case of the Murdered McKenzie</i>: When a faded movie beauty is accused of killing her rich husband, it seems like an open-and-shut case—until Masuto investigates. And it soon appears that murder is only the beginning of an even more shocking conspiracy.<br/>  <br/> “One of the best in the series.” —<i>The New York Times</i><br/>  <br/> As witty as he is wise, Detective Masuto is the brilliant creation of “one of the 20th century’s busiest writers” known for “creating stories that even his critics admired as page-turners (<i>The New York Times</i>).<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Howard Fast
      </h2>
      
      <p class="authorDescription body article">Howard Fast (1914&ndash;2003) was one of the most prolific American writers of the twentieth century. He was a bestselling author of more than eighty works of fiction, nonfiction, poetry, and screenplays. The son of immigrants, Fast grew up in New York City and published his first novel upon finishing high school in 1933. In 1950, his refusal to provide the United States Congress with a list of possible Communist associates earned him a three-month prison sentence. During his incarceration, Fast wrote one of his best-known novels, <i>Spartacus</i> (1951). Throughout his long career, Fast matched his commitment to championing social justice in his writing with a deft, lively storytelling style. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a24d8ec